module.exports =
  '_RECOMMEND':
    'USE_PC': 'スコア登録・情報編集はPCサイト、もしくはアプリをご利用ください。'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/modal/i18n/ja.coffee